import React from "react";
import { Icon } from "@iconify/react";

const NewsUpdatesComponent = () => {
    return (
        <div className="md:h-screen flex items-center w-11/12">
            <div>
                <h2 className="text-[#036F36] text-lg md:text-xl lg:text-3xl mb-3">
                    Policy News and Updates
                </h2>
                <p className="text-lg md:text-xl lg:text-2xl">
                    Get real-time updates on policy shifts, new regulations, and key events shaping agri-food systems. From groundbreaking reforms to must-attend workshops, conferences, and trainings - never miss a beat in the evolving policy ecosystem
                </p>
                <a href="/home-policy-updates">
                    <button className="common-button mt-3 ml-0 text-base md:text-lg lg:text-xl">
                        See What’s New
                        <Icon icon="maki:arrow" width="12" height="12" className="ml-2"/>
                    </button>
                </a>
            </div>
        </div>
    );
};

export default NewsUpdatesComponent;